import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import gradientImg from "../Assets/imgs/BG.jpg";
import Header from "./Header";
import HeroPanel from "./HeroPanel";
import Strategy from "./Strategy";
import LandScape from "./LandScape";
import Services from "./Services";
import CaseStudy from "./CaseStudy";
import OurCilents from "./OurCilents";
import Footer from "./Footer";
import bgVideo from "../Assets/imgs/BG.mp4";
const Home = () => {
  return (
    <>
      <div className="__gradientEffect">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="bg-video"
          preload="auto"
        >
          <source src={bgVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <Header />
      <HeroPanel />
      <Strategy />
      <LandScape />
      <Services />
      <CaseStudy />
      <OurCilents />
      <Footer />
    </>
  );
};

export default Home;
